module.exports = __webpack_public_path__ + "static/img/icon-changePassword.6c1e9e65.png";